import React from "react";

interface QuestionProps {
  question?: string;
  answers?: string[];
  onAnswer?: (answer: string) => void;
  selected?: string | string[] | null;
  translate: (key: string) => string;
  multiSelect?: boolean;


}

const Question: React.FC<QuestionProps> = ({
  question,
  answers = [],
  onAnswer,
  selected,
  translate,
  multiSelect = false,
}) => {
  const handleSelect = (answer: string) => {
    onAnswer?.(answer);
  };

  const isSelected = (answer: string) => {
    if (multiSelect && Array.isArray(selected)) {
      return selected.includes(answer);
    }
    return selected === answer;
  };

  return (
    <div className="w-full flex flex-col items-center mt-4 sm:mt-6">
      {/* Question text */}
      <h3
        className={`font-semibold text-gray-800 mb-3 sm:mb-4 text-center leading-tight `}
      >
        {question ? translate(question) : ""}
      </h3>

      {/* Answer options */}
      <div className="flex flex-col space-y-2 sm:space-y-3 w-full my-6 sm:my-8">
        {answers.slice(0, 5).map((answer) => (
          <button
            key={answer}
            type="button"
            onClick={() => handleSelect(answer)}
            aria-pressed={isSelected(answer)}
            className={`w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg border font-medium transition-colors  
              ${
                isSelected(answer)
                  ? "border-blue-600 text-blue-600 "
                  : "border-gray-400 text-gray-700 "
              }`}
          >
            {translate(answer)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Question;
